module.exports = __webpack_public_path__ + "static/img/jcb.3031f26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/jcb.svg
// module id = EopG
// module chunks = 1